import React, { useState } from "react";
import {
  Box,
  Fab,
  TextField,
  Typography,
  IconButton,
  Slide,
  Paper
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SendIcon from "@mui/icons-material/Send";

const WhatsAppWidget = ({
  phone = "916230206562",
  defaultMessage = "Hi, I am interested in Himachal / Ladakh / Uttarakhand tour."
}) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(defaultMessage);

  
  const handleSend = () => {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <Fab
        color="success"
        onClick={() => setOpen(!open)}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 2000
        }}
      >
        <WhatsAppIcon />
      </Fab>

      {/* Chat Box */}
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Paper
          elevation={6}
          sx={{
            position: "fixed",
            bottom: 90,
            right: 24,
            width: 320,
            borderRadius: 3,
            overflow: "hidden",
            zIndex: 2000
          }}
        >
          {/* Header */}
          <Box
            sx={{
              bgcolor: "#25D366",
              color: "white",
              p: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1
            }}
          >
            <WhatsAppIcon />
            <Typography fontWeight={600}>
              Travel Support
            </Typography>
          </Box>

          {/* Body */}
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              👋 Hi! Planning a trip to Himachal, Ladakh, J&K or Uttarakhand?
            </Typography>
          </Box>

          {/* Footer */}
          <Box
            sx={{
              p: 1.5,
              display: "flex",
              gap: 1,
              borderTop: "1px solid #eee"
            }}
          >
            <TextField
              size="small"
              fullWidth
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <IconButton
              color="success"
              onClick={handleSend}
            >
              <SendIcon />
            </IconButton>
          </Box>
        </Paper>
      </Slide>
    </>
  );
};

export default WhatsAppWidget;
